var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('UserAccountContainer', {
    attrs: {
      "user": _vm.user,
      "plan": _vm.getActivePlan,
      "sub": _vm.getActiveSubscription,
      "loadingSubscriptions": _vm.loadingSubscriptions
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85903496","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/AccountMgmt/AccountMgmt.vue
// module id = NDUX
// module chunks = 2